import React from 'react';
import HeroSlider from '../components/HeroSlider';
import AwardsSection from '../components/AwardsSection';
import BestImagesSection from '../components/BestImagesSection';
import ArtistProfile from '../components/ArtistProfile';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <div>
      <HeroSlider />
      
      {/* Section Divider */}
      <div className="border-t border-gray-200"></div>
      
      <AwardsSection />
      
      {/* Section Divider */}
      <div className="border-t border-gray-200"></div>
      
      <BestImagesSection />
      
      {/* Section Divider */}
      <div className="border-t border-gray-200"></div>
      
      <ArtistProfile />
      
      {/* Section Divider */}
      <div className="border-t border-gray-200"></div>
      
      <ContactSection />
    </div>
  );
};

export default HomePage;
